export default {
  presets: {
    light: {
      backgroundPrimary: '#f6f9fc',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#f6f9fc',
      backgroundCardSecondary: '#f6f9fc',
      success: '#228200',
      info: '#158DE3',
      danger: '#E42222',
      warning: '#FFD43A',
      primary: '#0073E6',
      base: '#0A2540',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
